import { render, staticRenderFns } from "./SfArrow.vue?vue&type=template&id=c9db9d3c&"
import script from "./SfArrow.vue?vue&type=script&lang=js&"
export * from "./SfArrow.vue?vue&type=script&lang=js&"
import style0 from "./SfArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports